import request from '@/utils/request'
// 查询职业测评列表
export function listCareerQuiz(query) {
    return request({
      url: '/business/careerQuiz/getQuizList',
      method: 'get',
      params: query
    })
  }
  //测评类型
  export function CareerQuizType(query) {
    return request({
      url: '/system/dict/data/type/tab_career_quiz',
      method: 'get',
      params: query
    })
  }
  //我的测评
  export function MecareerQuiz(query) {
    return request({
      url: '/business/careerQuiz/getMyQuiz',
      method: 'get',
      params: query
    })
  }
//内容详情 
export function careerQuizDetails(id) {
  return request({
    url: '/business/careerQuiz/'+id,
    method: 'get',
  })
}
//完成测评 
export function careerQuizover(data) {
  return request({
    url: '/business/careerQuiz/getAnswerResult',
    method: 'post',
    data:data
  })
}
//对结果进行评价
export function careerQuizPingjia(data) {
  return request({
    url: '/business/quizResult/evaluate',
    method: 'post',
    data:data
  })
}
//查询测评结果 
export function getresult(query) {
  return request({
    url: '/business/quizResult/getMyResult',
    method: 'get',
    params: query
  })
}